import { render, staticRenderFns } from "./LicenseeDetails.vue?vue&type=template&id=b2ac96f0"
import script from "./LicenseeDetails.vue?vue&type=script&lang=js"
export * from "./LicenseeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports